<main id="db-wrapper" class="bg-light">
    <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
    <section id="page-content">
      <div class="header">
        <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
        <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
      </div>
  
     <div class="container-fluid p-2">
      <div class="row mt-2 ps-2">
        <div class="col-lg-12">
            <h2>
              {{"businessLeads" | translate}}
            </h2>
        </div>
       </div>
        <div class="menu-container mb-20">
        
            <a *ngFor="let item of menuItems" [routerLink]="['/' + item.path]" class="card card-border-primary rounded-4 menu-item">
              <div class="card-body d-flex flex-column gap-3 text-center">
                <div>
                  <div class="icon-shape icon-xxl bg-light-primary rounded-circle">
                    <i [class]="getIcon(item.path)" class="menu-icon" style="color: blue !important;"></i>
                  </div>
                </div>
                <div>
                  <h5 class="mb-0">{{ item.label  | translate}}</h5>
                </div>
              </div>
            </a>
          </div>    
      </div>  
    </section>
  </main>
  <div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
    <app-bottom-nav></app-bottom-nav>
  </div>

  